import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { TranslateModule } from '@ngx-translate/core';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgApexchartsModule } from 'ng-apexcharts';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

import { AuthGuard } from 'app/auth/helpers';
import { Role } from 'app/auth/models';

import { NgSelectModule } from '@ng-select/ng-select';

import { CoreCommonModule } from '@core/common.module';

import { DashboardService } from 'app/main/dashboard/dashboard.service';

import { EcommerceComponent } from 'app/main/dashboard/ecommerce/ecommerce.component';
import { whenPipe } from '@core/pipes/dateformat.pipe';
import { BuyairtimeComponent } from './buyairtime/buyairtime.component';
import { BuydataComponent } from './buydata/buydata.component';
import { CabletvComponent } from './cabletv/cabletv.component';
import { CorporateComponent } from './corporate/corporate.component';
import { HistoryComponent } from './history/history.component';
import { MembershipComponent } from './membership/membership.component';
import { EducationComponent } from './education/education.component';
import { VoucherComponent } from './voucher/voucher.component';
import { ProfileComponent } from './profile/profile.component';
import { ElectricityComponent } from './electricity/electricity.component';
import { FundwalletComponent } from './fundwallet/fundwallet.component';
import { ContentHeaderModule } from "../../layout/components/content-header/content-header.module";
import { ChangePinComponent } from './change-pin/change-pin.component';
import { AllPagesComponent } from './all-pages/all-pages.component';
import { DatacardComponent } from './datacard/datacard.component';
import { TransferwalletComponent } from './transferwallet/transferwallet.component';

const routes = [
  // {
  //   path: 'analytics',
  //   component: AnalyticsComponent,
  //   canActivate: [AuthGuard],
  //   data: { animation: 'danalytics' },
  //   resolve: {
  //     css: DashboardService
  //   }
  // },
  {
    path: 'dashboard',
    component: EcommerceComponent,
    canActivate: [AuthGuard],
    resolve: {
      css: DashboardService
    },
    data: { animation: 'decommerce' }
  },
  {
    path: 'buyairtime',
    component: BuyairtimeComponent,
    canActivate: [AuthGuard],
    data: {animation: "wizard"}
  },
  {
    path: 'buydata',
    component: BuydataComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'cabletv',
    component: CabletvComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'corporate-gifting',
    component: CorporateComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'electricity',
    component: ElectricityComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'transaction-history',
    component: HistoryComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'upgrade-membership',
    component: MembershipComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'education',
    component: EducationComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'voucher',
    component: VoucherComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'transfer-wallet',
    component: TransferwalletComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'datacard',
    component: DatacardComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'change-pin',
    component: ChangePinComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'all-pages',
    component: AllPagesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'fundwallet',
    component: FundwalletComponent,
    canActivate: [AuthGuard],
  },
];

@NgModule({
    declarations: [
        EcommerceComponent,
        BuyairtimeComponent,
        BuydataComponent,
        CabletvComponent,
        CorporateComponent,
        AllPagesComponent,
        FundwalletComponent,
        ElectricityComponent,
        HistoryComponent,
        MembershipComponent,
        EducationComponent,
        TransferwalletComponent,
        DatacardComponent,
        VoucherComponent,
        ProfileComponent,
        ChangePinComponent
    ],
    providers: [DashboardService],
    exports: [EcommerceComponent],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        TranslateModule,
        ContentHeaderModule,
        NgbModule,
        NgSelectModule,
        PerfectScrollbarModule,
        CoreCommonModule,
        ContentHeaderModule
    ]
})
export class DashboardModule {}
